export default "__VITE_ASSET__876128a1__"